var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"marketing"},[_c('Header',{attrs:{"headTitle":"마케팅 동의","isShowBackBtn":""},on:{"clickBack":_vm.cancel}}),_c('div',{staticClass:"detail-page"},[_c('Marketing')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }